export enum ReferenceSkuUnitPriceType {
    Unit,
    Kilogram,
    Liter,
    Meter,
    SquareMeter,
    CubicMeter,
    Dozen,
    HalfDozen,
    OneHundredG,
    OneHundredMl,
    Dose,
}

export class ReferenceSkuUnitPrice {
    public type?: ReferenceSkuUnitPriceType;
    public price: number | null = null;
    public selected: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { type: ReferenceSkuUnitPriceType[json.type] });
    }

    public clone(): ReferenceSkuUnitPrice {
        const skuUnitPrice = new ReferenceSkuUnitPrice();

        skuUnitPrice.type = this.type;
        skuUnitPrice.price = this.price;

        return skuUnitPrice;
    }
}
